

import * as actionTypes from "./shopping-types";

export const addToCart =(itemID) =>{
    return {
        type:actionTypes.ADD_To_CART,
        payload:{
            id:itemID
        }
    }
}

export const checkOUtUpdate=(itemID)=>{
    return{
        type:actionTypes.CHECKOUT_UPDATE,
        payload:{
            id:itemID
        }
    }
}

export const removeFromCart =(itemID)=>{
    return{
        type:actionTypes.REMOVE_FROM_CART,
        payload:{
            id:itemID,
        },
    };

};

export const adjustQty =(itemID,value)=>{
    return{
        type:actionTypes.ADJUST_QTY,
        payload:{
            id:itemID,
            qty:value,
        },
    };
};

export const loadCurrentItem=(item)=>{
    return{
        type:actionTypes.LOAD_CURRENT_ITEM,
        payload:item
    }
}